import { computed } from 'vue';
import { resolveOroMxAvatarSrc } from '@/features/profile/oro-mx-avatar';
import { oroMxProfileLoginName } from '@/features/profile/oro-mx-player-identity';
import { t } from '@/shared/i18n/messages';
import { useSessionStore } from '@/stores/session-store';

/** 「我的」身份卡：主行登录名 / ID / 头像走 profile。 */
export function useOroMxPlayerIdentity() {
  const sessionStore = useSessionStore();

  const displayName = computed(
    () => sessionStore.player?.displayName || sessionStore.player?.loginName || t('oro.profile.guest'),
  );
  const loginName = computed(() =>
    oroMxProfileLoginName(sessionStore.player?.loginName, t('oro.profile.guest')),
  );
  const playerId = computed(
    () => sessionStore.player?.publicPlayerId || sessionStore.player?.playerUserId || '—',
  );
  const avatarSrc = computed(() => resolveOroMxAvatarSrc(sessionStore.player?.avatarUrl));

  async function hydrateIdentity() {
    if (!sessionStore.token) {
      return false;
    }
    return sessionStore.fetchProfile();
  }

  return { avatarSrc, displayName, hydrateIdentity, loginName, playerId, sessionStore };
}
